import { useState } from 'react';

const DEFAULT_ERROR_MSG = 'Something went wrong while submitting the form. Please try again.';

const useFormSubmitErroHandler = (setLoading) => {
    const [errorMsg, setErrorMsg] = useState(null);

    const onError = async (res) => {
        setErrorMsg(null);
        const message = res?.response?.data?.message || res?.message || DEFAULT_ERROR_MSG;
        setErrorMsg(message);
        setLoading && setLoading(false);
    };

    return { errorMsg, setErrorMsg, onError };
};

export default useFormSubmitErroHandler;